import api from '@/utils/api';

const controller = 'v1.0/credencial';
const credencialExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        CadastroCredencial: function (model) {
            return api.Axios.Post(controller, model);
        },
        AtualizarCredencial: function (model) {
            return api.Axios.PutWithoutId(controller, model);
        },
        GetById: function (id) {
            return api.Axios.Get(controller + "/" + id);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Todos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
        DeleteHeader: function (codigoHeader) {
            return api.Axios.Delete(controller + "/header/" + codigoHeader);
        },
    }
);

export default credencialExport;